export const SLIDE_TYPES = {
  HERO_3_COLUMN_LAYOUT: 'HERO_3_COLUMN_LAYOUT',
  HERO_FULL_IMAGE: 'HERO_FULL_IMAGE',
  SPOTLIGHT_WITH_RIGHT_IMAGE: 'SPOTLIGHT_WITH_RIGHT_IMAGE',
};

export const SLIDES_TYPE_OPTIONS = {
  [SLIDE_TYPES.SPOTLIGHT_WITH_RIGHT_IMAGE]: {
    value: SLIDE_TYPES.SPOTLIGHT_WITH_RIGHT_IMAGE,
    label: 'Spotlight with Right Image',
    description: 'Spotlight layout with image on right and content on left',
  },
  [SLIDE_TYPES.HERO_3_COLUMN_LAYOUT]: {
    value: SLIDE_TYPES.HERO_3_COLUMN_LAYOUT,
    label: '3 Column Layout with Heading and subHeading',
    description: '3 Column Layout for more control over the banner',
  },
  [SLIDE_TYPES.HERO_FULL_IMAGE]: {
    value: SLIDE_TYPES.HERO_FULL_IMAGE,
    label: 'Single Image Layout',
    description: 'Full Image Layout for a more immersive experience',
  },
};
